














































import Vue from 'vue';
import Component from 'vue-class-component';
import router from '@/router';
import { ObjectFactory } from '../config/objectFactory';
import { MedTransGoConstants } from '../util/constants';
import DataTable from '../components/DataTable.vue';
import { CommonUtils } from '../util/commonUtils';
import { ApiRequest, QueryRecordsRequest } from '../types/request';
import { DateUtils } from '../util/dateUtils';
import { MathUtils } from '../util/mathUtils';
import { Invoice, Payout } from '../types/entity';
import ViewRequestDetailModal from './modal/ViewRequestDetailModal.vue';
import { Condition } from '../types/queryRequest';


// tslint:disable-next-line: no-var-requires
const PayoutsTable = require('../datatable/PayoutsTable.json');
@Component({
    watch: {
        $route(to, from) {
            const request = this as Payouts;
            request.getPayoutList();
        },
    },
    methods: {
        goBack() {
            router.push({ name: MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME });
        },
    },
    components: {
        DataTable,
        ViewRequestDetailModal,
    },
})
export default class Payouts extends Vue {
    private payoutsDataSource = PayoutsTable;
    private show = true;
    private selectedStatus: string[] = [];
    private startDate = null;
    private endDate = null;

    private statusMapping: {[key: string]: string} = {
        Paid: 'Paid',
        Pending: 'Pending Admin Approval',
        Approved: 'Approved but Pending payment',
        Rejected: 'Rejected by Admin',
    };

    public mounted() {
        if (this.$store.state.isChildInterpreter) {
            this.show = false;
        }
        this.getPayoutList('', 0);
    }

    private showViewRequestModal(serviceRequest: any) {
        this.$router.push({ path: `/payouts/${serviceRequest.requestId}` });
    }

    private async getPayoutList(searchString?: string, start?: number, conditions?: Condition[]) {
        const response = await ObjectFactory.getRequestService().getPayouts({
            conditions: this.getFilterConditions(),
            start,
            limit: MedTransGoConstants.PAGINATION_LIMIT,
        }, this.$store.state.serverUrl);

        if (response.data && response.data.length > 0) {
            response.data = response.data.map((payout: any) => {
                // Add displayStatus field that maps to our new naming convention
                payout.displayStatus = this.statusMapping[payout.status] || payout.status;
                return payout;
            });
        }
        this.payoutsDataSource.data = response.data;
        if (response.totalCount) {
            this.payoutsDataSource.totalCount = response.totalCount;
        }
    }
    private getFilterConditions(): Condition[] {
        const filterConditions: Condition[] = [];
        /*
        if (this.selectedStatus && this.selectedStatus.length > 0) {
            const backendStatusValues = this.selectedStatus.map((status) => {
                switch (status) {
                    case 'Paid': return 'Paid';
                    case 'Pending Admin Approval': return 'Pending';
                    case 'Approved but Pending payment': return 'Approved';
                    case 'Rejected by Admin': return 'Rejected';
                    default: return status;
                }
           });
            filterConditions.push({
                op: 'in',
                fieldName: 'status',
                value: backendStatusValues,
            });
        }
        */
        if (this.startDate && this.endDate) {
            const startDate = DateUtils.convertToUTCInMillis(this.startDate);
            const endDate = DateUtils.convertToUTCInMillis(this.endDate);
            filterConditions.push({
                fieldName: 'appointment.timestamp',
                op: 'gte',
                value: startDate,
            });
            filterConditions.push({
                fieldName: 'appointment.timestamp',
                op: 'lte',
                value: endDate,
            });
        }
        return filterConditions;
    }

}
